// Central banner helpers for the learner portal.
//
// Banner announcements come from LE Salesforce: an Announcement whose Category
// is "Banner - red/blue/yellow" syncs to RDS as a category of `banner_red`,
// `banner_blue`, or `banner_yellow` (ULC-3147). These render as banners at the
// top of the app and must NOT appear in the regular announcement / notification
// lists. Keep the prefix and variant mapping in one place so every consumer
// agrees on what counts as a banner.

export const BANNER_CATEGORY_PREFIX = 'banner_';

const BANNER_VARIANTS = {
  banner_red: 'red',
  banner_blue: 'blue',
  banner_yellow: 'yellow'
};

// Whether an announcement category is a banner category.
export function isBannerCategory(category) {
  return typeof category === 'string' && category.startsWith(BANNER_CATEGORY_PREFIX);
}

// Map a banner_* category to a NoticeBanner color variant.
export function bannerVariantFromCategory(category) {
  return BANNER_VARIANTS[category] || 'yellow';
}

// Announcement bodies are rich text wrapped in block elements (p/div/li/...).
// Banners are a single inline strip rendered via v-html, and scoped styles do
// not reach v-html content, so drop the block-level wrappers here (keeping
// inline formatting like bold/italic/underline) and collapse whitespace.
export function bannerMessageFromBody(body) {
  return String(body || '')
    .replace(/<\/?(?:p|div|h[1-6]|ul|ol|li|blockquote|br|hr)\b[^>]*>/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
